import Cookies from 'js-cookie';
import ReactGA from 'react-ga4';
import {FunctionComponent, useEffect} from "react";
import { GA_MEASUREMENT_ID } from "../constants/general";

interface CookieModel {
    performance: number,
    functional: number,
    advertising: number,
}

const ConsentToGA: FunctionComponent = () => {

    useEffect(() => {
        ReactGA.initialize(GA_MEASUREMENT_ID);

        const cookie: string | undefined = Cookies.get('gwo-cookie-consent');

        if (cookie) {
            const cookieConsent: CookieModel = JSON.parse(cookie);
            toggleGA(cookieConsent.performance);
        }
    }, []);

    const optOutGA = (): void => {
        ReactGA.gtag('consent', 'update', {
            ad_storage: 'denied',
            analytics_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
        });
    };

    const optInGA = (): void => {
        ReactGA.set({allowAdFeatures: true});
        ReactGA.send('pageview');
        ReactGA.gtag("consent", "update", {
            ad_storage: 'granted',
            analytics_storage: 'granted',
            ad_user_data: 'granted',
            ad_personalization: 'granted',
        });
    };

    const toggleGA = (cookie: number): void => {
        if (cookie === 0) {
            return optOutGA();
        }

        return optInGA();
    }

    document.addEventListener('gwocookies:cookie-save', () => {
        window.location.reload();
    });

    return (
        <></>
    )
};

export default ConsentToGA;
